<ng-container *ngIf="wikiCard">
  <div class="header-btns-container" [class.remove-drag]="pageMode === 'window'">
    <ng-container *ngTemplateOutlet="switchViewButton"></ng-container>
    <ng-container *ngTemplateOutlet="expandButton"></ng-container>
    <square-button
      [active]="contextMenuActive"
      (click)="$event.stopPropagation(); openContextMenu($event)"
      (auxclick)="$event.stopPropagation(); openContextMenu($event)"
      (contextmenu)="$event.stopPropagation(); openContextMenu($event)"
      #actions
      >•••</square-button
    >
    <ng-container *ngIf="showCloseButton">
      <ng-container *ngTemplateOutlet="closeButton"></ng-container>
    </ng-container>
  </div>
</ng-container>

<ng-template #closeButton>
  <u-button
    class="icon-button-clean"
    elementSize="small"
    fontIcon="times"
    type="secondary"
    [styles]="{ fontSize: '20px', width: '28px', height: '28px' }"
    (onClick)="closePopup.emit(false)"
  ></u-button>
</ng-template>

<ng-template #expandButton>
  <u-button
    *ngIf="pageMode !== 'full'"
    class="icon-button-clean"
    [pTooltip]="expandOrCollapseTooltip"
    tooltipPosition="top"
    tooltipStyleClass="u-tooltip"
    elementSize="small"
    [fontIcon]="expandOrCollapseIcon"
    type="secondary"
    [styles]="{ fontSize: '14px', width: '28px', height: '28px' }"
    (onClick)="onOpenExternal()"
  ></u-button>
</ng-template>

<ng-template #switchViewButton>
  <u-button
    *ngIf="switchViewContent"
    [label]="switchViewContent.text"
    [fontIcon]="switchViewContent.icon"
    [iconStyles]="{ fontSize: '16px' }"
    elementSize="small28"
    type="secondary"
    [ngClass]="{ 'icon-button-clean': pageMode === 'inline', 'icon-square-button': !switchViewContent.text }"
    [pTooltip]="switchViewContent.tooltip"
    tooltipPosition="top"
    tooltipStyleClass="u-tooltip"
    (onClick)="onSwitchView()"
    [active]="switchButtonActive"
  ></u-button>
</ng-template>
